export const UPLOAD_QUERY_KEYS = {
  all: ['upload'] as const,
  credentials: (cId: number) => [...UPLOAD_QUERY_KEYS.all, 'credentials', cId] as const,
  ingestcfgs: (cId: number) => [...UPLOAD_QUERY_KEYS.all, 'ingestcfgs', cId] as const,
  jobs: (cId: number) => [...UPLOAD_QUERY_KEYS.all, 'jobs', cId] as const,
} as const;

export const VIDEO_EXTENSIONS = [
  '.mp4', '.mov', '.avi', '.mkv', '.webm', '.m4v', '.wmv', '.flv', '.mpg', '.mpeg',
] as const;

/** 64MB — optimal for media platform (top of AWS recommended 16-64MB range) */
export const MULTIPART_MIN_PART_SIZE = 67_108_864;

/** 6 hours — buffer before credential expiration to trigger refresh */
export const CREDENTIAL_EXPIRATION_BUFFER_SECS = 21_600;

/** 5s between backend progress reports */
export const PROGRESS_REPORT_THROTTLE_MS = 5_000;

/** Max concurrent file uploads — 1 file at a time since Uppy uploads 6 chunks in parallel per file */
export const MAX_CONCURRENT_FILE_UPLOADS = 1;

/** 300GB — professional media: multi-hour 4K at high bitrate */
export const MAX_UPLOAD_SIZE_BYTES = 322_122_547_200;

/** 5s when active uploads exist */
export const JOB_POLL_ACTIVE_INTERVAL_MS = 5_000;

/** 5 min — mark upload as error if no progress change */
export const UPLOAD_STALE_TIMEOUT_MS = 5 * 60 * 1_000;

/** 7 attempts, exponential backoff (reduced from legacy 60) */
export const UPLOAD_RETRY_DELAYS = [1_000, 2_000, 4_000, 8_000, 16_000, 32_000, 64_000] as const;
